import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LazyLoaderDirective } from 'src/app/core/loader/lazy-loader-directive/lazy-loader.directive';

@NgModule({
  declarations: [LazyLoaderDirective],
  imports: [CommonModule],
  exports: [LazyLoaderDirective]
})
export class LazyLoaderModule { }
